import React, { useState } from "react";
import ClientNavbar from "../layout/ClientNavbar";
import { NavLink } from "react-router-dom";

const TEAL = "#06b6a4";

const VIEW_TYPES = [
  { value: "on_screen", label: "On Screen" },
  { value: "pdf", label: "PDF" },
  { value: "excel", label: "Excel" },
  { value: "excel_unformatted", label: "Excel (Unformatted)" },
  { value: "email", label: "Email" },
];

const ASSET_CLASSES = [
  { value: "mutual_fund", label: "Mutual Fund" },
  { value: "share_bond", label: "Share & Bond" },
];

const FY_OPTIONS = [
  "FY 2025-2026",
  "FY 2024-2025",
  "FY 2023-2024",
  "FY 2022-2023",
];

const inputBorderStyle = { borderRadius: "8px", border: `1px solid ${TEAL}` };

export default function CapitalGainRealized() {
  const [viewType, setViewType] = useState("on_screen");
  const [assetClass, setAssetClass] = useState("mutual_fund");
  const [fyWise, setFyWise] = useState(true);
  const [customFy, setCustomFy] = useState("FY 2025-2026");
  const [investor, setInvestor] = useState("all_selected");
  const [casData, setCasData] = useState("include");
  const [applying, setApplying] = useState(false);

  const handleApply = () => {
    setApplying(true);
    setTimeout(() => setApplying(false), 600);
    // TODO: generate report based on filters
  };

  return (
    <>
      <ClientNavbar />
      <div className="page-content" style={{ background: "#f1f5f9", minHeight: "100vh" }}>
        {/* Header */}
        <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "12px" }}>
          <div className="card-body p-4">
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              <div>
                <h3 className="mb-2 text-primary">Capital Gain Realized</h3>
                <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none" }}>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <NavLink to="/overview">Dashboard</NavLink> /
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/reports/capital-gain-realized">Reports</NavLink> /
                    </li>
                    <li className="breadcrumb-item active">Capital Gain Realized</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>

        <div className="card shadow-sm p-4 mb-4" style={{ borderRadius: "12px", border: "1px solid #e2e8f0" }}>
          {/* View Type */}
          <div className="mb-4">
            <label className="form-label fw-semibold" style={{ color: "#334155", marginBottom: "10px" }}>
              View Type
            </label>
            <div className="d-flex flex-wrap gap-3">
              {VIEW_TYPES.map((opt) => (
                <label key={opt.value} className="d-flex align-items-center gap-2" style={{ cursor: "pointer" }}>
                  <input
                    type="radio"
                    name="viewType"
                    value={opt.value}
                    checked={viewType === opt.value}
                    onChange={() => setViewType(opt.value)}
                    style={{ accentColor: TEAL, width: 18, height: 18 }}
                  />
                  <span style={{ fontSize: "15px", color: "#475569" }}>{opt.label}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Assets Class */}
          <div className="mb-4">
            <label className="form-label fw-semibold" style={{ color: "#334155", marginBottom: "10px" }}>
              Assets Class
            </label>
            <div className="d-flex flex-wrap gap-3">
              {ASSET_CLASSES.map((opt) => (
                <label key={opt.value} className="d-flex align-items-center gap-2" style={{ cursor: "pointer" }}>
                  <input
                    type="radio"
                    name="assetClass"
                    value={opt.value}
                    checked={assetClass === opt.value}
                    onChange={() => setAssetClass(opt.value)}
                    style={{ accentColor: TEAL, width: 18, height: 18 }}
                  />
                  <span style={{ fontSize: "15px", color: "#475569" }}>{opt.label}</span>
                </label>
              ))}
            </div>
          </div>

          {/* FY wise / Custom Period */}
          <div className="mb-4">
            <div className="d-flex align-items-center gap-3 flex-wrap">
              <span className="fw-semibold" style={{ color: "#334155", fontSize: "15px" }}>FY wise</span>
              <div
                role="button"
                tabIndex={0}
                onClick={() => setFyWise(!fyWise)}
                onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && setFyWise(!fyWise)}
                className="form-check form-switch mb-0"
                style={{ cursor: "pointer" }}
              >
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={fyWise}
                  onChange={() => setFyWise(!fyWise)}
                  style={{ width: 44, height: 22, accentColor: TEAL, cursor: "pointer" }}
                />
              </div>
              <span className="fw-semibold" style={{ color: "#334155", fontSize: "15px" }}>Custom Period</span>
              {!fyWise && (
                <select
                  className="form-select form-select-sm"
                  value={customFy}
                  onChange={(e) => setCustomFy(e.target.value)}
                  style={{ ...inputBorderStyle, width: "auto", minWidth: "160px" }}
                >
                  {FY_OPTIONS.map((fy) => (
                    <option key={fy} value={fy}>{fy}</option>
                  ))}
                </select>
              )}
            </div>
          </div>

          {/* Filter */}
          <div className="mb-4">
            <label className="form-label fw-semibold" style={{ color: "#334155", marginBottom: "12px" }}>
              Filter
            </label>
            <div className="row g-3">
              <div className="col-md-4">
                <label className="form-label small text-muted">Investor :</label>
                <select
                  className="form-select form-select-sm"
                  value={investor}
                  onChange={(e) => setInvestor(e.target.value)}
                  style={inputBorderStyle}
                >
                  <option value="all_selected">All Selected</option>
                  <option value="primary">Primary</option>
                </select>
              </div>
              <div className="col-md-4">
                <label className="form-label small text-muted">CAS Data :</label>
                <select
                  className="form-select form-select-sm"
                  value={casData}
                  onChange={(e) => setCasData(e.target.value)}
                  style={inputBorderStyle}
                >
                  <option value="include">Include</option>
                  <option value="exclude">Exclude</option>
                </select>
              </div>
            </div>
          </div>

          {/* Apply */}
          <div className="d-flex justify-content-end pt-2">
            <button
              type="button"
              className="btn px-5 py-2"
              style={{
                background: TEAL,
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                fontWeight: "600",
                fontSize: "15px",
              }}
              onClick={handleApply}
              disabled={applying}
            >
              {applying ? "Applying…" : "Apply"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
